import { graphql } from "msw";
import { mockCustomer } from "./data";
export var handler = graphql.query("Customer", function (_req, res, ctx) {
  return res(ctx.data({
    customer: mockCustomer
  }));
});